exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n*[data-v-8b557db4] {\n  font-family: Moderat;\n  font-style: normal;\n  font-weight: normal;\n  /* #E4E5E7 */\n}\n.loader-container[data-v-8b557db4] {\n  height: 100vh;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.loading-wrapper[data-v-8b557db4] {\n  width: 400px;\n}\n", ""]);

// exports
